// extracted by mini-css-extract-plugin
export default {"wrapper":"History_wrapper__jRCXi","deleteButton":"History_deleteButton__TQF2k"};